// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dF-z","hovered":"eF-z","hoverImage":"fF-z","mainImage":"gF-z","imageNoBackground":"hF-z","fullSizeImage":"iF-z"};